import {
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  styled,
} from "@mui/material";
import {useRecoilState, useSetRecoilState} from "recoil";
import {alertStateAtom} from "../Recoil/Atom/AlertAtom";
import {snackBarState, snackBarToggleState} from "../Recoil/Atom/snackBarState";

const BootstrapDialog = styled(Dialog)(({theme}) => ({
  "& .css-17baijt-MuiPaper-root-MuiDialog-paper": {
    padding: "16px 32px",
  },
  "& .MuiDialogContent-root": {
    display: "flex",
    alignItems: "center",
  },
}));

const MWAlertDialog = () => {
  const [alertState, setAlertState] = useRecoilState(alertStateAtom);
  const setSnackBarState = useSetRecoilState(snackBarState);
  const setSnackBarToggle = useSetRecoilState(snackBarToggleState);

  const handleClickCancel = () => {
    setAlertState({...alertState, toggle: false});
    setSnackBarToggle(true);
    setSnackBarState("cancel");
  };

  const handleClickOk = () => {
    setAlertState({...alertState, toggle: false});
    alertState.execution();
    setSnackBarToggle(true);
    setSnackBarState("delete");
  };

  return (
    <Box>
      <BootstrapDialog
        open={alertState.toggle}
        onClose={handleClickCancel}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title">Alert Message</DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-description">{alertState.message}</DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClickCancel} color="error">
            Cancel
          </Button>
          <Button onClick={handleClickOk} autoFocus>
            OK
          </Button>
        </DialogActions>
      </BootstrapDialog>
    </Box>
  );
};

export default MWAlertDialog;
